/**
 * @name: 开发者账号关联APP逻辑处理
 * @param {
 *  props: 创建编辑信息
 *  id：操作对象id
 *  emit
 * }
 * @return  创建，编辑，停用，操作记录，续费
 */

import { ref, getCurrentInstance } from 'vue';
import { ElMessageBox, ElMessage } from 'element-plus';

import {
  AddAccountInfoApi,
  EditAccountInfoApi,
  DelAccountInfoApi,
  UpdateEnableApi,
} from '@/api/manage-app/app-info';
import { IAppInfoItem, GetV1AccountInfoApiResItem } from '@/api/manage-app/account-info/index.d';

export const useCreatedDevAPP = (
  props = {} as any,
  emit = '' as any,
) => {
  const currentInstance = getCurrentInstance()!;

  // 编辑
  const createdAPPVisible = ref<boolean>(false);
  const accountAppItem = ref({});
  const handelAppEdit = (row: IAppInfoItem) => {
    const {
      id,
      bundleId,
      appName,
      appClient,
      installAddress,
      accountId,
      accountInfoId,
    } = row;
    accountAppItem.value = {
      id,
      bundleId,
      appName,
      appClient,
      installAddress,
      accountId,
      accountInfoId,
    };
    createdAPPVisible.value = true;
  };

  // 创建
  const accountId = ref('');
  const accountInfoId = ref('');
  const handleAPPClose = () => {
    (currentInstance.refs.ruleAppForm as any).resetFields();
    emit('update:visible', false);
  };
  const handleAPPCreated = (row: GetV1AccountInfoApiResItem) => {
    accountId.value = row.accountId!;
    accountInfoId.value = row.id!;
    accountAppItem.value = {};
    createdAPPVisible.value = true;
  };
  const handleAPPSave = async () => {
    await (currentInstance.refs.ruleAppForm as any).validate();
    if (props.value.id) {
      await EditAccountInfoApi(props.value);
    } else {
      await AddAccountInfoApi(props.value);
    }
    ElMessage.success('操作成功！');
    emit('handleSearch');
    handleAPPClose();
  };

  // 启用或停用
  const handleAPPEnable = (row: IAppInfoItem, searchCb: any) => {
    ElMessageBox.confirm(`是否确认${row.isEnabled === 'YES' ? '停用' : '启用'} [${row.appName}] ？`, '温馨提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }).then(async () => {
      await UpdateEnableApi({
        id: row.id!,
        isEnabled: row.isEnabled === 'YES' ? 'NO' : 'YES',
      });
      ElMessage.success('操作成功！');
      searchCb();
    }).catch(() => {
    });
  };

  // 删除
  const handleAPPDel = (row: IAppInfoItem, searchCb: any) => {
    ElMessageBox.confirm(`是否确认删除 [${row.appName}] ？`, '温馨提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }).then(async () => {
      await DelAccountInfoApi(row.id);
      ElMessage.success('操作成功！');
      searchCb();
    }).catch(() => {
    });
  };

  return {
    // 创建
    createdAPPVisible,
    handleAPPCreated,
    handleAPPSave,
    handleAPPClose,
    accountId,
    accountInfoId,

    // 启用
    handleAPPEnable,
    // 删除
    handleAPPDel,
    // 编辑
    handelAppEdit,
    accountAppItem,
  };
};
